import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './Reducers/rootReducer';
import { setAuth, logout } from './Actions/authActions';
import axios from 'axios';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState = {}) {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
  );
  store.dispatch(setAuth());

  axios.interceptors.request.use(
    config => {
      // Do something before request is sent
      const token = store.getState().auth.token;
      config.headers.common['Authorization'] = `JWT ${token}`;
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error.response.status;
      if (status === 401) {
        store.dispatch(logout());
      }
      return Promise.reject(error.response);
    },
  );

  return store;
}
